<template>
  <transition name="toast-fade">
    <div v-show="show" class="toast">{{text}}</div>
  </transition>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      text: {
        type: String,
        default: ''
      },
      duration: {
        type: Number,
        default: 3000
      }
    },
    watch: {
      show (val) {
        if (val) {
          clearTimeout(this._timeout)
          this._timeout = setTimeout(() => {
            this.$emit('hidden')
          }, this.duration)
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .toast
    position fixed
    left 50%
    bottom 30%
    max-width px2rem(400px)
    height auto
    padding px2rem(12px) px2rem(15px)
    z-index 100
    font-size px2rem(28px)
    line-height 1.2
    text-align center
    color #fff
    background-color rgba(#000, 0.75)
    border-radius px2rem(10px)
    transform scale(1) translate3d(-50%, 0, 0)
    transform-origin 0 50%
    -webkit-transform scale(1) translate3d(-50%, 0, 0)
    /*-webkit-transform-origin 0 50%*/
  .toast-fade-enter-active
    transition all .25s ease
  .toast-fade-leave-active
    transition all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0)
  .toast-fade-enter, .toast-fade-leave-active
    opacity 0
    transform scale(0.01)
</style>



// WEBPACK FOOTER //
// toast.vue?1b32c907